import builder from '../builder';
import GridArtboard from '../../streamline-icons/bold/grid-artboard.svg';

export default builder('IconGridArtboardBold', GridArtboard);
